import React, { lazy } from "react";
import { Navigate } from "react-router-dom";
const PaymentLoader = lazy(() => import("../Pages/Payment/PaymentLoader"));
const RazorpayHandoff = lazy(() => import("../Pages/Payment/RazorpayHandoff"));
const CheckOrder = lazy(() => import("../Pages/Order/CheckOrder"));
const HealthConcernList = lazy(
  () => import("../Pages/CommonPages/HealthConcernList"),
);
const CategoryRedirect = lazy(
  () => import("../Pages/CommonPages/CategoryRedirect"),
);
const ReDirectPath = lazy(() => import("../Pages/ReDirectPaths/ReDirectPath"));
const QualityAssured = lazy(
  () => import("../Pages/CommonPages/QualityAssured"),
);
const StoreImages = lazy(() => import("../Pages/Store/StoreImages"));
const ViewByCategory = lazy(
  () => import("../Pages/CommonPages/ViewByCategory"),
);
const CustomerAllOrders = lazy(() => import("../Pages/Order/CustomerOrders"));
const CustomerCart = lazy(
  () => import("../Pages/HamburgerOptions/CustomerCart"),
);

const Wishlist = lazy(() => import("../Pages/HamburgerOptions/Wishlist"));
const FestivalPage = lazy(() => import("../Pages/Offers/FestivalPage"));
const ColourListing = lazy(() => import("../Pages/Offers/ColourListing"));
const PaymentStatus = lazy(() => import("../Pages/Payment/PaymentStatus"));
const OrderDetailPage = lazy(
  () => import("../Pages/Order/OrderDetail/OrderDetailPage"),
);
const Faq = lazy(() => import("../Pages/CommonPages/Faq"));
const LoginMerged = lazy(() => import("../Pages/UserAuths/LoginMerged"));
const VerifyOtp = lazy(() => import("../Pages/UserAuths/VerifyOtp"));
const Search = lazy(() => import("../Pages/Search/Search"));
const ProductDetailPageNew = lazy(
  () => import("../Pages/CommonPages/ProductDetailPageNew"),
);
const ProductRedirect = lazy(
  () => import("../Pages/CommonPages/ProductRedirect"),
);
const AboutPage = lazy(() => import("../Pages/CommonPages/AboutPage"));
const ReviewPage = lazy(() => import("../Pages/CommonPages/ReviewPage"));
const Policies = lazy(() => import("../Pages/CommonPages/Policies"));
const CookiePreferences = lazy(
  () => import("../Pages/CommonPages/CookiePreferences"),
);
const EmailUnsubscribe = lazy(
  () => import("../Pages/CommonPages/EmailUnsubscribe"),
);
const ProductUnavailable = lazy(
  () => import("../Pages/CommonPages/ProductUnavailable"),
);
const QAIndex = lazy(() => import("../Pages/CommonPages/QAIndex"));

// ── Cart → Checkout redesign — now the live /cart → /checkout flow ──
const CheckoutGallery = lazy(
  () => import("../Pages/CheckoutFlow/pages/CheckoutGallery"),
);
const CartPageNew = lazy(() => import("../Pages/CheckoutFlow/pages/CartPage"));
const CheckoutAddressNew = lazy(
  () => import("../Pages/CheckoutFlow/pages/AddressPage"),
);
const CheckoutPayNew = lazy(
  () => import("../Pages/CheckoutFlow/pages/PaymentPage"),
);
const OnePageCheckout = lazy(
  () => import("../Pages/CheckoutFlow/pages/OnePageCheckout"),
);
const OrderConfirmedNew = lazy(
  () => import("../Pages/CheckoutFlow/pages/OrderConfirmedPage"),
);

const ShopByCraft = lazy(() => import("../Pages/ShopByCraft/ShopByCraft"));
const CraftRedirect = lazy(() => import("../Pages/ShopByCraft/CraftRedirect"));
const VerifiedHandloom = lazy(
  () => import("../Pages/VerifiedHandloom/VerifiedHandloom"),
);
const Journal = lazy(() => import("../Pages/Journal/Journal"));
const Articel = lazy(() => import("../Pages/Articel/Articel"));
const ArticelRedirect = lazy(
  () => import("../Pages/Articel/ArticelRedirect"),
);

const CraftCluster = lazy(() => import("../Pages/EachCraft/CraftCluster"));
const BehindScenes = lazy(() => import("../Pages/BehindScenes/BehindScenes"));

const NavDrawer = lazy(() => import("../Pages/NavDrawer/NavDrawer"));
const Systemwishlist = lazy(
  () => import("../Pages/Systemwishlist/Systemwishlist"),
);
const LoginForm = lazy(() => import("../Pages/Login/Login"));
export const GlobalRoutes = [
  // {
  //   name: "product_detail_page_new",
  //   path: "/product-detail-page-new/:name/:id",
  //   element: <ProductDetailPageNew />,
  // },
  {
    // Redesigned cart is now the live entry — all existing links to
    // /cart land here. Old CustomerCart kept at /cart-legacy.
    name: "cart",
    path: "/cart",
    element: <CartPageNew />,
  },
  {
    name: "cart_legacy",
    path: "/cart-legacy",
    element: <CustomerCart />,
  },
  {
    // Old cart path → new /cart (PRD URL rename). Keeps bookmarks/shared links alive.
    name: "cart_redirect",
    path: "/cart-products",
    element: <Navigate to="/cart" replace />,
  },

  // ── Cart → Checkout redesign — live flow ───────────────────────────────────
  {
    name: "checkout_address",
    path: "/checkout/address",
    element: <CheckoutAddressNew />,
  },
  {
    name: "checkout_pay",
    path: "/checkout/pay",
    element: <CheckoutPayNew />,
  },
  {
    // One-page checkout (Address + Pay merged). The cart sends buyers here when
    // REACT_APP_ONE_PAGE_CHECKOUT is on (Utils/checkoutFlow.js).
    name: "checkout_one_page",
    path: "/checkout",
    element: <OnePageCheckout />,
  },
  {
    name: "order_confirmed",
    path: "/order-confirmed/:id",
    element: <OrderConfirmedNew />,
  },
  {
    // Dev-only review index of all mock ?case= screens.
    name: "checkout_gallery",
    path: "/checkout-new",
    element: <CheckoutGallery />,
  },
  {
    // PRD §3 canonical: /policies/{policy}. Dispatches slug → per-policy page.
    name: "policies",
    path: "/policies/:policy",
    element: <Policies />,
  },
  {
    name: "terms_and_conditions_redirect",
    path: "/terms-and-conditions",
    element: <Navigate to="/policies/terms" replace />,
  },
  {
    name: "privacy_policy_redirect",
    path: "/privacy-policy",
    element: <Navigate to="/policies/privacy" replace />,
  },
  {
    name: "faq",
    path: "/faq",
    element: <Faq />,
  },
  {
    name: "about",
    path: "/about",
    element: <AboutPage />,
  },
  {
    name: "reviews",
    path: "/reviews",
    element: <ReviewPage />,
  },
  {
    name: "returns_and_cancellation_policy_redirect",
    path: "/returns-and-cancellation-policy",
    element: <Navigate to="/policies/returns" replace />,
  },
  {
    name: "shipping_policy_redirect",
    path: "/shipping-policy",
    element: <Navigate to="/policies/shipping" replace />,
  },
  {
    name: "cookie_preferences",
    path: "/cookie-preferences",
    element: <CookiePreferences />,
  },
  {
    // Unsubscribe link in cart-recovery emails. Public: always reached from an inbox, logged out.
    name: "email_unsubscribe",
    path: "/email/unsubscribe",
    element: <EmailUnsubscribe />,
  },
  {
    // Reviewable sold / "Found a home" page. Production dead-URL routing
    // (PDP sold-state / backend 301) is deferred.
    name: "product_unavailable",
    path: "/product-unavailable",
    element: <ProductUnavailable />,
  },
  {
    // Dev QA index — links every redesigned surface. Not linked in the app.
    name: "qa_index",
    path: "/qa",
    element: <QAIndex />,
  },

  {
    path: "/auth/login",
    element: <LoginMerged />,
  },
  {
    path: "/auth/verify-otp",
    element: <VerifyOtp />,
  },
  {
    name: "search",
    path: "/search",
    element: <Search />,
  },
  {
    // PRD §3 canonical PDP: /product/{slug}/{id}. Backend resolves by :id;
    // the PDP self-corrects the :name slug on load.
    name: "product_details",
    path: "/product/:name/:id",
    element: <ProductDetailPageNew />,
  },
  {
    // Old /product-details/{slug}/{id} → /product/... Keeps shared PDP links
    // (incl. ?skuId=) alive.
    name: "product_details_redirect",
    path: "/product-details/:name/:id",
    element: <ProductRedirect />,
  },
  {
    name: "quality_assured",
    path: "/quality-assured",
    element: <QualityAssured />,
  },
  {
    name: "view-category",
    path: "/view-by-category",
    element: <ViewByCategory referrer={"category"} />,
  },
  {
    name: "view-by-category",
    path: "/type-details",
    element: <ViewByCategory referrer={"type_detail"} />,
  },
  {
    // PRD §3 canonical category/subcategory listing: /shop/{vertical}/{subcat}/{id}.
    // Backend resolves by :hct_id; :hct_type/:hct_name self-correct from API data.
    name: "shop-listing",
    path: "/shop/:hct_type/:hct_name/:hct_id",
    element: <HealthConcernList />,
  },
  {
    // Old /{vertical}/{subcat}/{id} → /shop/... Kept greedy/last (static-prefixed
    // routes still out-rank it), so old shared/bookmarked category links resolve.
    name: "health-concern-list-redirect",
    path: "/:hct_type/:hct_name/:hct_id",
    element: <CategoryRedirect />,
  },
  {
    name: "store-images",
    path: "/store-images",
    element: <StoreImages />,
  },
  {
    name: "requestUrls",
    path: "/requestedUrl",
    element: <ReDirectPath />,
  },
  {
    name: "prescribeOrder",
    path: "/prescribe/:id",
    element: <CheckOrder referrer="prescribeOrder" />,
  },
  {
    name: "customOrder",
    path: "/custom-order/:id",
    element: <CheckOrder referrer="customOrder" />,
  },
  {
    name: "aCart",
    path: "/acart/:id",
    element: <CheckOrder referrer="aCart" />,
  },
  {
    // PRD §3 canonical craft collection: /craft/{cluster}/{craftId}. Backend
    // resolves by :craftId; the page self-corrects the :cluster slug on load.
    name: "Craft",
    path: "/craft/:cluster/:craftId",
    element: <ShopByCraft />,
  },
  {
    // Old craft paths → /craft/{cluster}/{craftId}. Keeps shared links alive.
    name: "ShopByCraftRedirect",
    path: "/shop-by-craft",
    element: <CraftRedirect />,
  },
  {
    name: "ShopByCraftByIdRedirect",
    path: "/shop-by-craft/:craftId",
    element: <CraftRedirect />,
  },
  {
    name: "VerifiedHandloom",
    path: "/verified-handloom",
    element: <VerifiedHandloom />,
  },
  {
    name: "Journal",
    path: "/journal",
    element: <Journal />,
  },
  {
    // PRD §3 canonical article route: /journal/{slug}/{id}. Backend resolves by
    // :id; the article page self-corrects the :slug once loaded.
    name: "JournalArticle",
    path: "/journal/:slug/:id",
    element: <Articel />,
  },
  {
    // Old /articel?id=N → /journal/{slug}/{id}. Keeps shared/bookmarked links alive.
    name: "ArticelRedirect",
    path: "/articel",
    element: <ArticelRedirect />,
  },
  {
    name: "CraftCluster",
    path: "/craft-cluster/:fashionSubCatId",
    element: <CraftCluster />,
  },
  {
    // Legacy pillar URLs → single param page. Kept so existing "See all crafts" links resolve.
    name: "ClothCraft",
    path: "/cloth-craft",
    element: <Navigate to="/craft-cluster/1" replace />,
  },
  {
    name: "JewelryCraft",
    path: "/jewellery-craft",
    element: <Navigate to="/craft-cluster/2" replace />,
  },
  {
    name: "BehindScenes",
    path: "/behind-the-scene",
    element: <BehindScenes />,
  },
  {
    name: "NavDrawer",
    path: "/nav-drawer",
    element: <NavDrawer />,
  },
  {
    name: "Systemwishlist",
    path: "/system-wishlist",
    element: <Systemwishlist />,
  },
  {
    name: "LoginForm",
    path: "/login-form",
    element: <LoginForm />,
  },
  {
    // Razorpay payment leg of the custom-domain hand-off. Only ever opened on a store's own
    // <slug>.wcommerce.store subdomain, where Razorpay's registered-website check passes; bounces
    // back to the custom domain as soon as Checkout closes.
    //
    // MUST stay in GlobalRoutes: this page is always reached unauthenticated. Neither the login
    // token nor the guest session crosses an origin boundary, so even a logged-in buyer lands here
    // with no user — under ProtectedLayout they'd be redirected to the store home instead of paying.
    // Deliberately not under /checkout/*, whose static children (/checkout/address, /checkout/pay)
    // a dynamic segment would shadow.
    name: "razorpay_handoff",
    path: "/pay/:orderNumber",
    element: <RazorpayHandoff />,
  },
  // ── PayU return surfaces ──────────────────────────────────────────────────
  // All three MUST be public. A buyer coming back from PayU arrives on a cold cross-origin return
  // with no auth token and no guest session, and guest checkout is supported — under ProtectedLayout
  // every guest was silently redirected to the store home after paying, never seeing an outcome.
  {
    name: "payu-payment",
    path: "/payments/:id",
    element: <PaymentLoader />,
  },
  {
    name: "payment_status",
    path: "/payment-success/:id",
    element: <PaymentStatus status="success" />,
  },
  {
    name: "payment_status",
    path: "/payment-failed/:id",
    element: <PaymentStatus status="failed" />,
  },
  {
    // Festival page "See all gold clothing". The fixed first segment ranks this above the
    // three-segment `/:hct_type/:hct_name/:hct_id` category redirect, which would otherwise read
    // "yellow" as a category id and bounce the shopper to the home page.
    name: "festival_colour_listing",
    path: "/offers/colour/:swatch",
    element: <ColourListing />,
  },
  {
    // Festival page: <store>/diwali, <store>/karwa-chauth. ONE pattern serves every festival
    // there will ever be -- a new festival is a DB row, not a route, the same way
    // /product/:name/:id serves every product.
    //
    // PUBLIC by definition: this is the link sellers put in an Instagram bio, so it must never
    // ask a shopper to log in. It spent one commit in ProtectRoutes and bounced every visitor
    // to the home page, which is exactly what a shared link must not do.
    //
    // It matches ANY single segment, so React Router's ranking is what protects the rest of the
    // app: static paths outrank dynamic ones, leaving /cart, /search and every existing page
    // untouched. Only paths nothing else claims reach here, and FestivalPage 404s the ones that
    // are not real festivals. Kept last for readability; ranking, not order, is what decides.
    name: "festival_page",
    path: "/:festivalSlug",
    element: <FestivalPage />,
  },
];
export const ProtectRoutes = [
  {
    name: "customer_all_orders",
    path: "/orders",
    element: <CustomerAllOrders />,
  },
  {
    // Old orders path → new /orders (PRD URL rename). Keeps bookmarks alive.
    name: "customer_all_orders_redirect",
    path: "/customer/all-orders",
    element: <Navigate to="/orders" replace />,
  },
  {
    // PRD §3 canonical order detail: /orders/{orderId} (internal orderId in the
    // path → refresh/deep-link safe). In-app orders list & cards link here.
    name: "order_details",
    path: "/orders/:orderId",
    element: <OrderDetailPage />,
  },
  {
    // Legacy surface kept for the external order-NUMBER deep-link flow
    // (ReDirectPath + payment pages hit /customer/order-detail?orderId=<number>
    // → get_order_detail_number). Not used by in-app navigation anymore.
    name: "order_details_by_number",
    path: "/customer/order-detail",
    element: <OrderDetailPage />,
  },
  {
    name: "wishlist",
    path: "/wishlist",
    element: <Wishlist />,
  },
];
